import React from 'react';
import { Pagination, Form } from 'react-bootstrap';
import '../appstyles/ClientsCSS/ClientsList.css';

const ListPaginator = ({
  currentPage,
  totalPages,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [10, 20, 50, 100],
  className = '',
}) => {
  // Create pagination items
  const paginationItems = [];
  for (let number = 1; number <= totalPages; number++) {
    if (
      number === 1 ||
      number === totalPages ||
      (number >= currentPage - 2 && number <= currentPage + 2)
    ) {
      paginationItems.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => onPageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    } else if (number === currentPage - 3 || number === currentPage + 3) {
      paginationItems.push(<Pagination.Ellipsis key={`ellipsis-${number}`} />);
    }
  }

  return (
    <div className={`list-paginator-row ${className}`}>
      <div className="paginator-group">
          <Pagination style={{ marginBottom: 0, marginRight: 18 }}>
            <Pagination.First onClick={() => onPageChange(1)} disabled={currentPage === 1} />
            <Pagination.Prev onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} />
            {paginationItems}
            <Pagination.Next onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} />
            <Pagination.Last onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages} />
          </Pagination>
        <div className="rows-dropdown-stack">
          <label htmlFor="rowsPerPageSelect" style={{ fontWeight: 500, fontSize: 13, color: '#333', marginBottom: 2, textAlign: 'center' }}>Filas</label>
          <Form.Select
            id="rowsPerPageSelect"
            value={rowsPerPage}
            onChange={e => onRowsPerPageChange(Number(e.target.value))}
            style={{ width: 70, minWidth: 70, fontSize: 14, boxShadow: 'none', textAlign: 'left' }}
          >
            {rowsPerPageOptions.map(opt => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </Form.Select>
        </div>
      </div>
    </div>
  );
};

export default ListPaginator;
